import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initFilter() {
  const checkboxes = document.querySelectorAll(".js-filter-checkbox");
  const trigger = document.querySelector(".js-filter-trigger");
  const dropdown = document.querySelector(".js-filter-dropdown");
  const items = document.querySelectorAll(".works-thumbnail");
  const container = document.querySelector(".works-list");
  const paginationEl = document.getElementById("js-works-pagination");

  const isArchive = document.querySelector(".archive-works-thumbnail");

  if (!items.length || !container) return;

  // -------------------------------------------------------
  // ドロップダウン開閉
  // -------------------------------------------------------
  if (trigger && dropdown) {
    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains("is-open");
      trigger.setAttribute("aria-expanded", String(!isOpen));
      dropdown.classList.toggle("is-open");
    });

    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target) && e.target !== trigger) {
        trigger.setAttribute("aria-expanded", "false");
        dropdown.classList.remove("is-open");
      }
    });
  }

  // -------------------------------------------------------
  // ページング・スクロール
  // -------------------------------------------------------
  function getPerPage() {
    if (isArchive) return window.innerWidth >= 768 ? 24 : 12;
    if (window.innerWidth < 576) return 6;
    if (window.innerWidth < 768) return 8;
    return 12;
  }

  function scrollToContainer() {
    const headerOffset = 220;
    const rect = container.getBoundingClientRect();
    window.scrollTo({
      top: window.pageYOffset + rect.top - headerOffset,
      behavior: "smooth",
    });
  }

  function getPageNumbers(current, total) {
    const delta = 1;
    const range = [];
    for (let i = 1; i <= total; i++) {
      if (
        i === 1 ||
        i === total ||
        (i >= current - delta && i <= current + delta)
      ) {
        range.push(i);
      }
    }
    const withDots = [];
    let prev = null;
    for (const page of range) {
      if (prev !== null && page - prev > 1) withDots.push("…");
      withDots.push(page);
      prev = page;
    }
    return withDots;
  }

  function renderPagination(totalItems, perPage) {
    if (!paginationEl) return;
    const totalPages = Math.ceil(totalItems / perPage);
    paginationEl.innerHTML = "";

    if (!isArchive || totalPages <= 1) {
      paginationEl.style.display = "none";
      return;
    }

    paginationEl.style.display = "flex";

    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.classList.add("works-pagination__prev");
    prevBtn.innerHTML = `<span class="arrow"><svg width="5" height="10" viewBox="0 0 5 10" fill="none"><path d="M5 0V10L0 5L5 0Z" fill="currentColor"/></svg></span><span>Prev</span>`;
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener("click", () => {
      if (currentPage > 1) {
        currentPage--;
        applyFilter(false, true);
        scrollToContainer();
      }
    });
    paginationEl.appendChild(prevBtn);

    const numbersWrap = document.createElement("div");
    numbersWrap.classList.add("works-pagination__numbers");
    getPageNumbers(currentPage, totalPages).forEach((page) => {
      if (page === "…") {
        const dots = document.createElement("span");
        dots.classList.add("works-pagination__dots");
        dots.textContent = "…";
        numbersWrap.appendChild(dots);
        return;
      }
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = page;
      btn.classList.add("works-pagination__btn");
      if (page === currentPage) btn.classList.add("is-current");
      btn.addEventListener("click", () => {
        currentPage = page;
        applyFilter(false, true);
        scrollToContainer();
      });
      numbersWrap.appendChild(btn);
    });
    paginationEl.appendChild(numbersWrap);

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.classList.add("works-pagination__next");
    nextBtn.innerHTML = `<span>Next</span><span class="arrow"><svg width="5" height="10" viewBox="0 0 5 10" fill="none"><path d="M0 10V0L5 5L0 10Z" fill="currentColor"/></svg></span>`;
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.addEventListener("click", () => {
      if (currentPage < totalPages) {
        currentPage++;
        applyFilter(false, true);
        scrollToContainer();
      }
    });
    paginationEl.appendChild(nextBtn);
  }

  // -------------------------------------------------------
  // フィルタリング（AND条件）
  // -------------------------------------------------------
  let isAnimating = false;
  let currentPage = 1;

  function getChecked() {
    // { project_type: Set, building_type: Set } の形で返す
    const checked = { project_type: new Set(), building_type: new Set() };
    checkboxes.forEach((cb) => {
      if (cb.checked) checked[cb.dataset.type].add(cb.dataset.value);
    });
    return checked;
  }

  function getMatched() {
    const checked = getChecked();
    const hasProject = checked.project_type.size > 0;
    const hasBuilding = checked.building_type.size > 0;

    // 何もチェックされていなければ全件
    if (!hasProject && !hasBuilding) return Array.from(items);

    return Array.from(items).filter((item) => {
      // project_type チェックがあれば AND 条件で評価
      if (hasProject) {
        const v = item.dataset.projectType || "";
        if (!checked.project_type.has(v)) return false;
      }
      // building_type チェックがあれば AND 条件で評価（複数値はカンマ区切り）
      if (hasBuilding) {
        const vals = (item.dataset.buildingType || "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
        const matchesBuilding = vals.some((v) => checked.building_type.has(v));
        if (!matchesBuilding) return false;
      }
      return true;
    });
  }

  function applyFilter(skipAnimation, isPageChange) {
    const perPage = getPerPage();
    const matched = getMatched();
    const start = isArchive ? (currentPage - 1) * perPage : 0;
    const end = isArchive ? start + perPage : perPage;
    const visible = matched.slice(start, end);

    // 該当実績がない場合の処理
    const noResult = document.querySelector(".works-noResult");
    if (noResult) {
      noResult.style.display = matched.length === 0 ? "block" : "none";
    }

    // フィルタ件数をトリガーボタンに反映
    const checkedCount = document.querySelectorAll(
      ".js-filter-checkbox:checked",
    ).length;
    if (trigger) {
      trigger.dataset.count = checkedCount > 0 ? checkedCount : "";
      trigger.classList.toggle("is-active", checkedCount > 0);
    }

    renderPagination(matched.length, perPage);

    if (skipAnimation || isPageChange) {
      items.forEach((item) => item.classList.add("is-none"));
      visible.forEach((item) => item.classList.remove("is-none"));
      if (noResult)
        noResult.style.display = matched.length === 0 ? "block" : "none";
      isAnimating = false;
      return;
    }

    // タブ切り替えアニメーション
    const currentHeight = container.offsetHeight;
    const visibleItems = Array.from(items).filter(
      (item) => !item.classList.contains("is-none"),
    );

    items.forEach((item) => item.classList.add("is-none"));
    visible.forEach((item) => item.classList.remove("is-none"));
    const newHeight = container.scrollHeight;
    items.forEach((item) => item.classList.add("is-none"));
    visibleItems.forEach((item) => item.classList.remove("is-none"));

    container.style.height = currentHeight + "px";
    requestAnimationFrame(() => {
      items.forEach((item) => item.classList.add("is-hidden"));
      container.style.height = newHeight + "px";
    });

    setTimeout(() => {
      items.forEach((item) => item.classList.add("is-none"));
      visible.forEach((item) => item.classList.remove("is-none"));
      setTimeout(() => {
        items.forEach((item) => item.classList.remove("is-hidden"));
        setTimeout(() => {
          container.style.height = "auto";
          isAnimating = false;
          ScrollTrigger.refresh();
        }, 300);
      }, 30);
    }, 500);
  }

  // チェックボックス変更時
  checkboxes.forEach((cb) => {
    cb.addEventListener("change", () => {
      if (isAnimating) {
        cb.checked = !cb.checked;
        return;
      } // アニメ中は無視
      isAnimating = true;
      currentPage = 1;
      applyFilter(false);
    });
  });

  // 初期表示
  applyFilter(true);

  // リサイズ
  let resizeTimer = null;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      currentPage = 1;
      applyFilter(true);
    }, 200);
  });
}
